import { render, staticRenderFns } from "./ProjectRecrRate.vue?vue&type=template&id=0fb87b8f&"
import script from "./ProjectRecrRate.vue?vue&type=script&lang=js&"
export * from "./ProjectRecrRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports